export class InfplBaseProperties {
  infplId?: string | null;
  infplPublisher: string | null;
  infplPublisherName: string | null;
  infplHash: string | null;
  infplAanmaakDatum: string | null;
  infplLaatstGewijzigd: string | null;
  infplLaatstGesynced: string | null;
  infplBeoordeling: any | null;
  infplOrganizationId: string | null;

  bboxRD: string;
  bboxLatlng: string;

  constructor() {
    this.infplId = null;
    this.infplPublisher = null;
    this.infplPublisherName = null;
    this.infplHash = null;
    this.infplAanmaakDatum = null;
    this.infplLaatstGewijzigd = null;
    this.infplLaatstGesynced = null;
    this.infplBeoordeling = null;
    this.infplOrganizationId = null;
    
    this.bboxRD = '';
    this.bboxLatlng = '';
  }
}
